import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/pro-solid-svg-icons";
import { useState } from "react";

type PagingSectionProps = {
    maxRecords: number;
    selectedPage: number;
    changePage: (pageNr: number) => void;
    pageSize?: number;
};

export const PagingSection = ({ maxRecords, selectedPage, changePage, pageSize = 15 }: PagingSectionProps) => {
    const numPages = Math.ceil(maxRecords / pageSize);
    const [currentPage, setCurrentPage] = useState(1);
    const minPage = 1;
    const maxPage = numPages;
    const nrOfPagesToShow = Math.min(numPages, 5);

    const nextPage = () => {
        const nextPage = Math.min(numPages, currentPage + 1);
        setCurrentPage(nextPage);
        changePage(nextPage);
    };

    const previousPage = () => {
        const nextPage = Math.max(1, currentPage - 1);
        setCurrentPage(nextPage);
        changePage(nextPage);
    };

    const goToPage = (pageNr: number) => {
        setCurrentPage(pageNr);
        changePage(pageNr);
    };

    const pagesArray = () => {
        const halfLimit = Math.floor(nrOfPagesToShow/2);
        let lowerLimit = Math.max(currentPage - halfLimit, 1);

        if (currentPage + halfLimit > numPages){
            lowerLimit = Math.max(numPages-nrOfPagesToShow+1, 1);
        }
        return Array.from({ length: nrOfPagesToShow }, (_, i) => i + lowerLimit);
    };

    return (
        <div className="text-black focus:text-white focus:bg-primary-500 flex flex-row gap-3">
            <button
                onClick={previousPage}
                className={`w-9 h-9 rounded-full ${
                    currentPage === minPage ? "bg-grayAlpha-300 text-white" : "bg-white"
                }`}
            >
                <FontAwesomeIcon icon={faAngleLeft} />
            </button>
            {pagesArray().map((pageNr) => {
                return (
                    <button
                        key={pageNr}
                        onClick={() => goToPage(pageNr)}
                        className={`w-9 h-9 rounded-full ${
                            pageNr === selectedPage ? "bg-primary-500 text-white" : "bg-white"
                        }`}
                    >
                        {pageNr.toString()}
                    </button>
                );
            })}
            <button
                onClick={nextPage}
                className={`w-9 h-9 rounded-full ${
                    currentPage === maxPage ? "bg-grayAlpha-300 text-white" : "bg-white"
                }`}
            >
                <FontAwesomeIcon icon={faAngleRight} />
            </button>
        </div>
    );
};
